var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInviteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.3652C17.2091 12.3652 19 10.5744 19 8.36523C19 6.1561 17.2091 4.36523 15 4.36523C12.7909 4.36523 11 6.1561 11 8.36523C11 10.5744 12.7909 12.3652 15 12.3652Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.3652C8.9 14.3652 7 18.3652 7 18.3652V20.3652H23V18.3652C23 18.3652 21.1 14.3652 15 14.3652Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.36523V15.3652",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.3652H1",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInviteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/InviteIcon.a72b37f3ffa3c91f42f3eb8b670e9708.svg";